import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useCurrentPatientFile } from './_components/patient-file.provider'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useParams } from 'react-router-dom'

export const PatientIdPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const projectId = Number(params.projectId)
  const patientId = Number(params.patientId)
  const location = useLocation()
  const pathname = location.pathname
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { patientFollowupsToShow } = useCurrentPatientFile()

  if (!projectId || !patientId) throw new Error(t('common.error.wrong-project-id-or-patient-id'))

  useEffect(() => {
    const queryParams = searchParams.toString() ? `?${searchParams.toString()}` : ''
    if (patientFollowupsToShow?.length && patientFollowupsToShow[0]) {
      navigate(`${pathname}/${patientFollowupsToShow[0].id}${queryParams}`, { replace: true })
      return
    }

    navigate(`${pathname}/add-patient-followup`, { replace: true })
  }, [patientFollowupsToShow?.length, pathname, navigate, searchParams])

  return null
}
